import { action, observable , computed} from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { setTokenBundle, setFirstRefreshFlag } from "app/api/localTools"
import { startRefresher } from "app/vendor/util"
import { message } from 'antd'
import AlloyLever from 'alloylever'

bindErrorCollector({
  cdn: 'https://res.wx.qq.com/mmbizwap/zh_CN/htmledition/js/vconsole/3.0.0/vconsole.min.js',
  reportUrl:  `${config.backend}/error/report`,
  reportPrefix: 'pgxcloud-frontend-web',
  reportKey: 'msg',
  entry: '#ZanXus'
})

function bindErrorCollector(params) {
  AlloyLever.config({
    ...params
  })
}

export default class {
  @observable formType = "login"
  @observable userInfo = {}
  @observable locked = false
  @observable apps = []

  @action updateFormType = (region) => {
    this.formType = region
  }

  /*
   * res contains userId, displayName, token, refreshToken
   */
  @action login = (data) => (
    request.post(`${config.backend}/auth`)
      .send(data)
      .type("application/json")
      .commonDispose()
      .then(res => {
        if (res.token) {
          setTokenBundle(JSON.stringify(res))
          setFirstRefreshFlag()
          startRefresher()
        }
      })
  )

  @action getPushAuth = () => {
    return request.get(`${config.backend}/users/app/setting`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.pushAuth = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action loadUserInfo() {
    return request.get(`${config.backend}/users`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.userInfo = res
        bindErrorCollector({otherReport: {userId: res.id}})
      })
  }

  @computed get needLoadApps () {
    return this.apps.length === 0
  }

  @action getApps () {
    return request.get(`${config.backend}/users/apps`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.apps = res
      })
  }

  @action setPassword(data) {
    return request.put(`${config.backend}/users/password`)
      .checkToken()
      .send(data)
      .commonDispose()
  }

  @action resetPassword(data) {
    return request.put(`${config.backend}/users/changepsw`)
      .send(data)
      .commonDispose()
  }

  @action sendVerifyCode(phone) {
    return request.post(`${config.backend}/codes`)
      .send({ type: "verify", phone })
      .commonDispose()
  }

  @action getUserSetting() {
    return request.get(`${config.backend}/users/settings`)
      .checkToken()
      .commonDispose()
  }

  @action updateUserSetting(newUserSetting) {
    return request.put(`${config.backend}/users/settings`)
      .send(newUserSetting)
      .checkToken()
      .commonDispose()
  }

  @action bindPhone = (bindInfo) => {
    return request.post(`${config.backend}/users/phone`)
      .send(bindInfo)
      .checkToken()
      .commonDispose()
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/auth.js